export const CreditStatusEnum = {
    ACTIVE:"فعال",
    EXPIRE:"منقضی",
    SUSPEND:"معلق"
}
